var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-switcher",class:[
    _vm.switcherStateClass,
    `variant-${_vm.variant}`,
    {
      'text-before': _vm.textBefore,
      'text-hide': _vm.textHide,
      'is-disabled': _vm.disabled
    }
  ]},[_c('div',{staticClass:"switcher-text"},[_vm._v("\n    "+_vm._s(_vm.switcherState ? _vm.switcherTextOn : _vm.switcherTextOff)+"\n    "),_c('div',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.switcherTextOn))]),_c('div',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.switcherTextOff))])]),_c('button',{staticClass:"switcher-wrapper",on:{"click":function($event){$event.preventDefault();return _vm.toggleSwitcher.apply(null, arguments)}}},[_c('div',{staticClass:"switcher-on"},[_c('font-awesome-icon',{attrs:{"icon":"check","size":"xs"}})],1),_c('div',{staticClass:"switcher-handle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }